import { Card } from "@mui/material";
import {
	FrontendBatchType,
	FrontendCompanyTestCategory,
	FrontendCompanyTestHierarchyNode,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleInstance,
} from "node-library/dist/portal";
import { useTranslation } from "react-i18next";
import InstanceInfoCardContent from "../../common/InstanceInfoCardContent";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	selectedTestCategory: FrontendCompanyTestCategory;
	hierarchyNodeParentMap: Map<string, FrontendCompanyTestHierarchyNode[]>;

	instance: FrontendSampleInstance;
	batchType: FrontendBatchType;
	isBatched: boolean;
	isSelectedAsVerifySample: boolean;
	selectAsInstanceToVerify: () => void;
	onDragStart?: (e: React.DragEvent, instance: FrontendSampleInstance) => void;
	requireDuplicateInstance: boolean;
	openSpecReadingDrawer: () => void;
}

export default function BatchGenerationInstanceCard(props: Props) {
	const { t: translation } = useTranslation();

	const {
		company,
		instance,
		hierarchyNodeParentMap,
		selectedTestCategory,
		batchType,
		onDragStart,
		isSelectedAsVerifySample,
		isBatched,
		selectAsInstanceToVerify,
		requireDuplicateInstance,
		openSpecReadingDrawer,
	} = props;

	const instanceBody: React.ReactNode = (
		<InstanceInfoCardContent
			company={company}
			selectedTestCategory={selectedTestCategory}
			hierarchyNodeParentMap={hierarchyNodeParentMap}
			instance={instance}
			batchType={batchType}
			isBatched={isBatched}
			isSelectedAsVerifySample={isSelectedAsVerifySample}
			selectAsInstanceToVerify={selectAsInstanceToVerify}
			requireDuplicateInstance={requireDuplicateInstance}
			openSpecReadingDrawer={openSpecReadingDrawer}
		></InstanceInfoCardContent>
	);
	return (
		<Card
			className="card-border-radius-14p card-small-padding "
			key={instance.sampleInstanceId}
			// sx={{ backgroundColor: "#F3F3F5" }}
			draggable
			onDragStart={(e) => onDragStart?.(e, instance)}
			style={{
				cursor: "grab",
				border: "1px solid lightgrey",
				backgroundColor: "#fff",
			}}
		>
			{instanceBody}
		</Card>
	);
}
